import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'font-awesome/css/font-awesome.min.css'
import "react-datepicker/dist/react-datepicker.css"
import { Provider } from 'react-redux'
import store from './redux/index'
import Loading from './components/view/loading'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Loading >
        <App />
     </Loading>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
